import {
  createYandexMetrikaReachGoal,
  createYandexMetrikaSetParams,
  activateYandexMetrika,
  activateTop100,
  activateTnsCounter
} from '@rambler-id/metrics'

import {createTrackEvent, createTrackPageview} from '@rambler-id/metrics'

const TOP100_KEY = 3115342
const YANDEX_METRIKA_ID_KEY = 29123130
const YANDEX_METRIKA_PORTAL_KEY = 26649402
const TNS_ACCOUNT = 'rambler_ru'
const TNS_TMSEC = 'rambler_mail'

export const reachGoal = createYandexMetrikaReachGoal(YANDEX_METRIKA_ID_KEY)
export const reachPortalGoal = createYandexMetrikaReachGoal(
  YANDEX_METRIKA_PORTAL_KEY
)
export const setParams = createYandexMetrikaSetParams(YANDEX_METRIKA_ID_KEY)

export const setPortalUserParams = createYandexMetrikaSetParams(
  YANDEX_METRIKA_PORTAL_KEY
)

export const trackEvent = createTrackEvent(TOP100_KEY)
export const trackPageview = createTrackPageview(TOP100_KEY)

export const activateMetrics = async (): Promise<void> => {
  await Promise.all([
    activateYandexMetrika([
      {counterKey: YANDEX_METRIKA_ID_KEY},
      {counterKey: YANDEX_METRIKA_PORTAL_KEY}
    ]),
    activateTop100({
      counterKey: TOP100_KEY,
      dataset: ['cerber-topline', 'cerber-id']
    }),
    activateTnsCounter({account: TNS_ACCOUNT, tmsec: TNS_TMSEC})
  ])
}
